const urls = [
  {
    pattern: /\/courses\/manage\/\d+\/dashboard/g,
    showVideo: true,
  },

  {
    // The manage-v2 course Dashboard tab has no help video yet. Match it here,
    // before the generic /dashboard rule below (which would otherwise suppress
    // it), so it shows the "Video de ajuda brevemente" button like the other
    // course tabs and keeps the "Gestão do curso" title bar in flow.
    pattern: /\/courses\/manage-v2\/\d+\/dashboard/g,
    comingSoon: true,
    title: "Brevemente",
  },

  {
    pattern: /\/dashboard/g,
    showVideo: false,
  },

  {
    pattern: /\/reports\/documents/g,
    videoId: "https://www.youtube.com/embed/VviZeVTCqxI",
    kbUrl: "https://ajuda.salespark.io/help/documentos-fiscais?version=latest",
    title: "Documentos Fiscais",
  },

  {
    pattern: /\/products\/list/g,
    videoId: "https://www.youtube.com/embed/GDrw-M5tDsU",
    // kbUrl: "https://ajuda.salespark.io/help/documentos-fiscais?version=latest",
    title: "Lista de Produtos",
  },

  //
  // {
  //   pattern: /\/products/g,
  //   videoId: "1",
  //   title: "Produtos",
  // },
];

function findPathInUrls(path, urls) {
  return urls.find((url) => new RegExp(url?.pattern).test(path));
}

const getVideo = (path) => {
  if (!path) return undefined;

  const matchingUrl = findPathInUrls(path, urls);

  if (matchingUrl !== undefined) {
    if (matchingUrl.showVideo === false) {
      return undefined;
    }

    return matchingUrl;
  }

  // No video defined for this page: button shows disabled ("Brevemente"), no modal
  return {
    comingSoon: true,
    title: "Brevemente",
  };
};

export default getVideo;
